import TagsWorkOrderSelectModal from '@/components/Settings/Profiles/TagsWorkOrder/TagsWorkOrderSelectModal';
import { useDisclosure } from '@/hooks';
import './style.less';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { Button, Tooltip } from 'antd';
import { Group } from '@/components/_common';
import { X } from 'react-feather';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import StatusTag from '@/components/_common/StatusTag';
import { useWorkOrderComplementIncludeTag } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';
import { truncateString } from '@/utils/functions/truncateString';

export default function ComplementHeaderTag() {
  const {
    complement: { data: complement },
    workorder: { data: workorder },
  } = useWorkorderDetailContext();
  const [modalSelectTag, modalSelectTagActions] = useDisclosure();

  const { mutateAsync: includeTagMutate, isLoading } =
    useWorkOrderComplementIncludeTag();

  const workOrderTag = complement?.workOrderTag;

  async function handleComplementTag(tagId?: number | null) {
    if (workorder && complement) {
      await includeTagMutate({
        workorderId: workorder.id,
        complementId: complement.id,
        tagId,
      });
    }
  }

  return (
    <>
      <Group gap={4}>
        {!!workOrderTag ? (
          <>
            <Tooltip title={workOrderTag.name.toUpperCase() || ''}>
              <StatusTag
                size="lg"
                color={workOrderTag.color}
                label={truncateString(workOrderTag.name.toUpperCase(), 20)}
                onClick={modalSelectTagActions.open}
              />
            </Tooltip>

            <Button
              icon={<AntdFeatherIcon icon={<X cursor="pointer" />} size={14} />}
              size="small"
              onClick={() => handleComplementTag(null)}
            />
          </>
        ) : (
          <StatusTag
            color="default"
            size="lg"
            className="card-select-tag"
            label="Selecionar Etiqueta"
            onClick={modalSelectTagActions.open}
          />
        )}
      </Group>

      <TagsWorkOrderSelectModal
        onCancel={modalSelectTagActions.close}
        open={modalSelectTag}
        onCallback={handleComplementTag}
        confirmLoading={isLoading}
      />
    </>
  );
}
